/* eslint-disable no-unused-vars -- 핸들러는 아래 restHandlers 배열에서 주석 토글로 활성화 */
import { addProductAttachmentHandlers } from './addProductAttachment/handlers';
import { checkUserStatusHandlers } from './checkUserStatus/handlers';
import { createAiChatHandlers } from './createAiChat/handlers';
import { createDetailHandlers } from './createDetail/handlers';
import { createProductHandlers } from './createProduct/handlers';
import { createVideoHandlers } from './createVideo/handlers';
import { deleteDetailHandlers } from './deleteDetail/handlers';
import { deleteProductAssetsHandlers } from './deleteProductAssets/handlers';
import { deleteProductsHandlers } from './deleteProducts/handlers';
import { deleteVideosHandlers } from './deleteVideos/handlers';
import { errorHandlers } from './error/handlers';
import { getDetailListHandlers } from './getDetailList/handlers';
import { getMetaDataHandlers } from './getMeta/handlers';
import { getProductHandlers } from './getProduct/handlers';
import { getUserProfileHandlers } from './getUserProfile/handlers';
import { listBannersHandlers } from './listBanners/handlers';
import { listProductsHandlers } from './listProducts/handlers';
import { listVideosHandlers } from './listVideos/handlers';
import { readDetailHandlers } from './readDetail/handlers';
import { readVideoHandlers } from './readVideo/handlers';
import { saveAsDetailHandlers } from './saveAsDetail/handlers';
import { updateCanvasHandlers } from './updateCanvas/handlers';
import { updateDetailHandlers } from './updateDetail/handlers';

export const restHandlers = [
  // ...getMetaDataHandlers,
  // ...getUserProfileHandlers,
  // ...checkUserStatusHandlers,
  // ...listProductsHandlers,
  // ...createProductHandlers,
  // ...createAiChatHandlers,
  // ...createDetailHandlers,
  // ...getDetailListHandlers,
  // ...getProductHandlers,
  // ...readDetailHandlers,
  // ...saveAsDetailHandlers,
  // ...updateDetailHandlers,
  // ...updateCanvasHandlers,
  // ...deleteDetailHandlers,
  // ...deleteProductsHandlers,
  // ...deleteProductAssetsHandlers,
  // ...imageGenerationHandlers,
  // ...addProductAttachmentHandlers,
  // ...errorHandlers,
  // ...listVideosHandlers,
  // ...readVideoHandlers,
  // ...createVideoHandlers,
  // ...deleteVideosHandlers,
  // ...listBannersHandlers,
];
